import Shape from 'pxc-editor-core/entities/Shape';

export default (data) => {
  const { page, shields } = data;
  const updatedPage = JSON.parse(JSON.stringify(page));

  for (const layoutId in updatedPage.layouts) {
    const layout = updatedPage.layouts[layoutId];
    for (const groupId in layout.groups) {
      const group = layout.groups[groupId];
      for (const shieldId in group.shields) {
        const shield = group.shields[shieldId];
        if (shield.isMatrix && shields.includes(shieldId)) {
          group.shields[shieldId] = Shape.toInitShieldState(shield);
        }
      }
    }
  }

  return updatedPage;
};
